/**
 * @fileoverview GET handler for the "/engagement/api/suppression_lists_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementApiSuppressionListsSettings } from "./constants";
import type { EngagementApiSuppressionListsSettingsResult } from "./types";
import { isEngagementApiSuppressionListsSettingsResult } from "./validators";

export const getEngagementApiSuppressionListsSettings = reactQueryFetcherAdapter(
  engagementApiSuppressionListsSettings,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementApiSuppressionListsSettingsResult> => {
    return fetch(
      "/engagement/api/suppression_lists_settings",
      "GET",
      {
        params: {
          app_group_id: appGroupId,
        },
      },
      { signal }
    );
  },
  isEngagementApiSuppressionListsSettingsResult
);
